// extracted by mini-css-extract-plugin
module.exports = {"language":"changeLangButtons_language__27W3-","baldLang":"changeLangButtons_baldLang__2Qlpj","langs":"changeLangButtons_langs__7v2k8"};